// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.homeBox {
  padding-top: 7rem;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.Avatar {
  width: 30rem;
  height: 30rem;
  box-sizing: border-box;
  border: 5px rgb(34 211 238) solid;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 0 5px 15px 0px rgb(243, 251, 255);
  transform: translatey(0px);
  animation: float 6s ease-in-out infinite;
  img {
    width: 100%;
    height: auto;
  }
}
.image-hover {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  transition: opacity 1s ease-out;
  margin-top: -9rem;
}
.image-hover:hover {
  opacity: 1;
}

h1 {
  --a: -45deg; /* control the angle */
  --t: 0.23em; /* thickness of the underline */
  --i: 30rem;
}

.homeName {
  --_s: calc(var(--t) * cos(var(--a)));
  background: linear-gradient(
      var(--a),
      #0000 var(--_s),
      currentColor 0 calc(100% - var(--_s)),
      #0000 0
    )
    bottom/var(--i, 90%) var(--t) no-repeat;
  padding: 0 0.25em calc(var(--t) + 0.1em);
  -webkit-box-decoration-break: clone;
  box-decoration-break: clone;
  transition: 0.3s;
  cursor: pointer;
}
h1:hover span {
  --i: 100%;
}

h1 {
  font-size: 4.5rem;
  font-weight: bold;
  line-height: 1.5;
  color: rgb(34 211 238);
}

@keyframes float {
  0% {
    box-shadow: 0 5px 15px 0px rgba(128, 128, 128, 0.6);
    transform: translatey(0px);
  }
  50% {
    box-shadow: 0 25px 15px 0px rgba(128, 128, 128, 0.2);
    transform: translatey(-50px);
  }
  100% {
    box-shadow: 0 5px 15px 0px rgba(128, 128, 128, 0.6);
    transform: translatey(0px);
  }
}

@media screen and (max-width: 767px) {
  .homeBox {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .Avatar {
    display: inline-block;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    align-content: center;
    justify-items: center;
    align-self: center;
    width: 20rem;
    height: 20rem;
  }

  .image-hover {
    margin-top: -5.9rem;
    align-self: center;
  }

  span {
    --i: 100%;
  }

  h1 {
    margin-left: 0.5rem;
    margin-top: 1.5rem;
    --t: 0.06em; /* thickness of the underline */
    font-size: 3rem;
  }

  .rotWords {
    margin-top: -2rem;
    margin-left: -0.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Styles/Home.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,6CAA6C;EAC7C,0BAA0B;EAC1B,wCAAwC;EACxC;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,+BAA+B;EAC/B,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW,EAAE,sBAAsB;EACnC,WAAW,EAAE,+BAA+B;EAC5C,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC;;;;;;2CAMyC;EACzC,wCAAwC;EACxC,mCAAmC;EACnC,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE;IACE,mDAAmD;IACnD,0BAA0B;EAC5B;EACA;IACE,oDAAoD;IACpD,4BAA4B;EAC9B;EACA;IACE,mDAAmD;IACnD,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,qBAAqB;IACrB,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,qBAAqB;IACrB,kBAAkB;IAClB,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,WAAW,EAAE,+BAA+B;IAC5C,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;AACF","sourcesContent":[".homeBox {\r\n  padding-top: 7rem;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.Avatar {\r\n  width: 30rem;\r\n  height: 30rem;\r\n  box-sizing: border-box;\r\n  border: 5px rgb(34 211 238) solid;\r\n  border-radius: 50%;\r\n  overflow: hidden;\r\n  box-shadow: 0 5px 15px 0px rgb(243, 251, 255);\r\n  transform: translatey(0px);\r\n  animation: float 6s ease-in-out infinite;\r\n  img {\r\n    width: 100%;\r\n    height: auto;\r\n  }\r\n}\r\n.image-hover {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  opacity: 0;\r\n  transition: opacity 1s ease-out;\r\n  margin-top: -9rem;\r\n}\r\n.image-hover:hover {\r\n  opacity: 1;\r\n}\r\n\r\nh1 {\r\n  --a: -45deg; /* control the angle */\r\n  --t: 0.23em; /* thickness of the underline */\r\n  --i: 30rem;\r\n}\r\n\r\n.homeName {\r\n  --_s: calc(var(--t) * cos(var(--a)));\r\n  background: linear-gradient(\r\n      var(--a),\r\n      #0000 var(--_s),\r\n      currentColor 0 calc(100% - var(--_s)),\r\n      #0000 0\r\n    )\r\n    bottom/var(--i, 90%) var(--t) no-repeat;\r\n  padding: 0 0.25em calc(var(--t) + 0.1em);\r\n  -webkit-box-decoration-break: clone;\r\n  box-decoration-break: clone;\r\n  transition: 0.3s;\r\n  cursor: pointer;\r\n}\r\nh1:hover span {\r\n  --i: 100%;\r\n}\r\n\r\nh1 {\r\n  font-size: 4.5rem;\r\n  font-weight: bold;\r\n  line-height: 1.5;\r\n  color: rgb(34 211 238);\r\n}\r\n\r\n@keyframes float {\r\n  0% {\r\n    box-shadow: 0 5px 15px 0px rgba(128, 128, 128, 0.6);\r\n    transform: translatey(0px);\r\n  }\r\n  50% {\r\n    box-shadow: 0 25px 15px 0px rgba(128, 128, 128, 0.2);\r\n    transform: translatey(-50px);\r\n  }\r\n  100% {\r\n    box-shadow: 0 5px 15px 0px rgba(128, 128, 128, 0.6);\r\n    transform: translatey(0px);\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 767px) {\r\n  .homeBox {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n\r\n  .Avatar {\r\n    display: inline-block;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    align-content: center;\r\n    justify-items: center;\r\n    align-self: center;\r\n    width: 20rem;\r\n    height: 20rem;\r\n  }\r\n\r\n  .image-hover {\r\n    margin-top: -5.9rem;\r\n    align-self: center;\r\n  }\r\n\r\n  span {\r\n    --i: 100%;\r\n  }\r\n\r\n  h1 {\r\n    margin-left: 0.5rem;\r\n    margin-top: 1.5rem;\r\n    --t: 0.06em; /* thickness of the underline */\r\n    font-size: 3rem;\r\n  }\r\n\r\n  .rotWords {\r\n    margin-top: -2rem;\r\n    margin-left: -0.5rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
